"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { AnimateIcon } from "@/components/animate-ui/icons/icon";
import { CctvIcon } from "@/components/animate-ui/icons/cctv";

/**
 * DemoModeHeader - Demo mode indicator banner for demo.outfame.com
 *
 * Spans full width, sits above the main content area.
 * Shows demo mode indicator with CTA to start growing (/setup).
 *
 * Features:
 * - Fixed height (40px mobile, 44px desktop) to prevent layout shifts
 * - Animated CCTV icon that plays on hover
 * - Pink CTA with hover arrow animation
 */

// Header height constants for consistent layout offsets
export const DEMO_HEADER_HEIGHT = {
  mobile: 40,
  desktop: 44
};
function DemoModeHeader() {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AnimateIcon animate={true} loop={true} loopDelay={8000}><div className="flex cursor-default items-center gap-2"><CctvIcon size={18} className="text-white" /><span className="text-[15px] font-bold text-white">Demo Mode</span></div></AnimateIcon>;
    t1 = <span className="hidden text-white/30 md:inline">·</span>;
    t2 = <span className="hidden text-white/60 md:inline">Preview your dashboard</span>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-center gap-3 bg-ink px-3 py-2 font-dashboard text-sm text-white md:gap-4 md:px-4 md:py-2.5">{t0}{t1}{t2}<Link href="https://www.outfame.com/setup" className="group flex shrink-0 items-center gap-1.5 rounded-button bg-pink px-3 py-1.5 text-xs font-semibold text-black transition-all duration-200 hover:bg-pink-dark active:scale-[0.98] active:opacity-80 md:px-4 md:text-sm">Start Growing<ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 md:h-4 md:w-4" /></Link></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default DemoModeHeader;